import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaMeta, FaXTwitter, FaInstagram } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom'; // Import the useNavigate hook

const Footer = () => {
  const navigate = useNavigate(); // Get the navigate function

  return (
    <footer className="footer">
      <Container>
        <Row className='x6'>
          <Col md={6}>
            <p className="footer-text mb-0">&copy; {new Date().getFullYear()} Deepstone Capital</p>
            <span className="xx footer-text" onClick={() => navigate('/terms-of-use')}>Terms of Use</span>
            <span className="xx footer-text" onClick={() => navigate('/privacy-policy')}>Privacy Policy</span>
          </Col>
          <Col md={4} className="text-md-end">
          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="footer-icon">
            <FaInstagram />
          </a>         
          <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="footer-icon">
            <FaMeta />
          </a>  
          <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="footer-icon">
            <FaXTwitter />
          </a>   
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
